(() => {
  'use strict';
  if (window.MNLAtelierMotion) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observed = new Set();
  const active = new Map();
  let suspended = false;
  const allowed = () => !reduced.matches && !document.hidden && !suspended;
  function collect(root) {
    if (!root || !root.querySelectorAll) return [];
    const elements = Array.from(root.querySelectorAll('[data-at-reveal]'));
    if (root.matches && root.matches('[data-at-reveal]')) elements.unshift(root);
    return elements;
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const element = entry.target;
      if (!entry.isIntersecting || !allowed() || !observed.has(element)) continue;
      observer.unobserve(element);
      observed.delete(element);
      if (seen.has(element) || element.isConnected === false) continue;
      seen.add(element);
      if (typeof element.animate !== 'function' || element === document.activeElement ||
          (element.contains && element.contains(document.activeElement))) continue;
      try {
        const animation = element.animate([
          { opacity: 0.72, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 320, easing: 'cubic-bezier(.2,.65,.2,1)' });
        active.set(animation, element);
        Promise.resolve(animation.finished).then(() => active.delete(animation), () => active.delete(animation));
      } catch (_) {}
    }
  }, { threshold: 0.12 }) : null;
  function scan(root) {
    if (!observer || !allowed()) return;
    for (const element of collect(root)) {
      if (seen.has(element) || observed.has(element) || element.isConnected === false) continue;
      observed.add(element);
      observer.observe(element);
    }
  }
  function cancel(root) {
    const targets = root ? new Set(collect(root)) : null;
    for (const [animation, element] of active) {
      if (targets && !targets.has(element)) continue;
      try { animation.cancel(); } catch (_) {}
      active.delete(animation);
    }
  }
  function disconnect() {
    if (observer) observer.disconnect();
    observed.clear();
  }
  const onChange = () => {
    if (!allowed()) { cancel(); disconnect(); }
    else scan(document);
  };
  if (reduced.addEventListener) reduced.addEventListener('change', onChange);
  else if (reduced.addListener) reduced.addListener(onChange);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    cancel(event.target);
    for (const element of collect(event.target)) {
      if (observer) observer.unobserve(element);
      observed.delete(element);
    }
  });
  document.addEventListener('focusin', event => {
    for (const [animation, element] of active) {
      if (element !== event.target && !(element.contains && element.contains(event.target))) continue;
      try { animation.cancel(); } catch (_) {}
      active.delete(animation);
    }
  });
  document.addEventListener('visibilitychange', onChange);
  window.addEventListener('pagehide', () => { suspended = true; cancel(); disconnect(); });
  window.addEventListener('pageshow', () => { suspended = false; scan(document); });
  scan(document);
  window.MNLAtelierMotion = { version: '1480', scan };
})();
